import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  orders: [],
  totalPage: 0,
};

export const myOrdersSlice = createSlice({
  name: "myOrders",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(sagaActions.ORDERS_LOAD_REQUEST, (state, action) => {
        state.totalPage = 0;
        state.orders = [];
      })
      .addCase(sagaActions.ORDERS_LOAD, (state, action) => {
        state.totalPage = action.data.totalPage;
        state.orders = action.data.orders;
      });
  },
});

export default myOrdersSlice.reducer;
